import React from 'react';

export default function ImplBlock3Responsibilities() {
  return (
    <section className="py-24 md:py-24 px-6 md:px-16 bg-surface border-t border-line">
      <div className="max-w-[1280px] mx-auto">
        
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-[24px] md:text-[32px] lg:text-[48px] font-bold text-ink mb-6 tracking-tight leading-[1.2]">
            La red aporta contexto y capacidad clínica. BAC aporta operación.
          </h2>
          <p className="text-[16px] md:text-[20px] text-ink-soft leading-[1.6]">
            La red define población, reglas autorizadas, capacidad y decisiones clínicas. BAC transforma esas definiciones en trabajo operacional priorizado, ejecutable y trazable.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8 lg:gap-16 max-w-5xl mx-auto">
          
          <div className="flex-1 bg-[rgb(239,239,255)] border border-line p-8 md:p-12 rounded-xl">
            <div className="text-[18px] font-extrabold text-brand tracking-widest uppercase mb-8 border-b border-line pb-4">
              RED / APS
            </div>
            <ul className="space-y-4">
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-brand mr-3 mt-1">-</span> Población
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-brand mr-3 mt-1">-</span> Fuentes acordadas
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-brand mr-3 mt-1">-</span> Reglas autorizadas
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-brand mr-3 mt-1">-</span> Capacidad disponible
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-brand mr-3 mt-1">-</span> Prestaciones clínicas
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-brand mr-3 mt-1">-</span> Decisiones profesionales
              </li>
            </ul>
          </div>

          <div className="flex-1 bg-[#ccccff] p-8 md:p-12 rounded-xl border border-brand/20">
            <div className="text-[18px] font-extrabold text-ink-soft tracking-widest uppercase mb-8 border-b border-brand/20 pb-4">
              BAC OPERA
            </div>
            <ul className="space-y-4 mb-8">
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Evaluación operacional
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Priorización
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Contacto
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Coordinación
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Asignación según capacidad disponible
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Confirmación
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Rescate
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Verificación
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Continuidad
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Excepciones
              </li>
              <li className="text-[18px] text-ink flex items-start">
                <span className="text-ink-soft mr-3 mt-1">-</span> Trazabilidad
              </li>
            </ul>
            <div className="bg-[#efefff] p-4 rounded-xl border-l-2 border-brand/40">
              <p className="text-[14px] text-ink-soft leading-[1.6]">
                Según el flujo acordado, las acciones pueden ser ejecutadas por automatización, BAC Operator o capacidades de la red. BAC mantiene la coordinación y trazabilidad operacional de la trayectoria.
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
